import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'antd';

import Body from './components/Body/Body';
import { handleOnAggregationTableChange } from 'utils/table/table';

import listingStyles from '../Listing/Listing.module.css';
import styles from './Rental.module.css';

const handleOnClickClearAll = setQuery => {
  const newQuery = {
    pagination: { current: 1, pageSize: 10 },
    filters: {},
    sorter: {}
  };
  handleOnAggregationTableChange(newQuery, setQuery);
};

const handleOnTableChange = setQuery => newQuery => {
  handleOnAggregationTableChange(newQuery, setQuery);
};

const Rental = ({ isAllowEditRental }) => {
  const [query, setQuery] = useState({});

  return (
    <Card className={listingStyles.card}>
      <div className={`${listingStyles.header} ${styles.header}`}>
        <Button onClick={() => handleOnClickClearAll(setQuery)}>Reset All</Button>
      </div>
      <div>
        <Body query={query} isAllowEditRental={isAllowEditRental} onTableChange={handleOnTableChange(setQuery)} />
      </div>
    </Card>
  );
};

Rental.propTypes = {
  isAllowEditRental: PropTypes.bool.isRequired
};

export default Rental;
